import axios from "axios";
import { basicurl, token } from "../ServiceUrl/url";

export const getAccountSummaryAPI = async ({ intake = '', organization = '', university = '' } = {}) => {
    const query = `?intake=${intake}&organization=${organization}&university=${university}`;
    let res = await axios.get(basicurl + "/api/student/get-account-summary" + query, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return res;
};

/**
 * Every intake students are actually filed under, newest first.
 *
 * Read from the data rather than generated, so a semester outside the usual
 * window - Fall 2030, or any Summer intake - can still be filtered for.
 */
export const getStudentIntakesAPI = async () => {
  let res = await axios.get(basicurl + "/api/student/student-intakes", {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

/** How many students sit at each step, grouped by university or organisation. */
export const getPayoutProgressByScopeAPI = async ({
  scope = "university",
  intake = "",
  university = "",
} = {}) => {
  let query = `?scope=${scope}&intake=${encodeURIComponent(intake)}`;
  if (university) query += `&university=${encodeURIComponent(university)}`;
  let res = await axios.get(
    basicurl + "/api/student/payout-progress-by-scope" + query,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res;
};

/**
 * One tracking station per intake, for a single university or organisation.
 *
 * Newest semester first, with every intake on record returned alongside so
 * the filter can be built without a second call.
 */
export const getPayoutProgressByIntakeAPI = async ({
  universityId = "",
  organizationId = "",
  university = "",
  intake = "",
} = {}) => {
  const params = new URLSearchParams();
  if (universityId) params.set("universityId", universityId);
  if (organizationId) params.set("organizationId", organizationId);
  if (university) params.set("university", university);
  if (intake) params.set("intake", intake);

  let res = await axios.get(
    basicurl + "/api/student/payout-progress-by-intake?" + params.toString(),
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res;
};

/**
 * The history behind one university or organisation, newest first.
 *
 * Paged rather than fetched whole: this grows forever by design, and the
 * reader almost always wants the last few things that happened.
 */
export const getPayoutActivityAPI = async ({
  universityId = "",
  organizationId = "",
  intake = "",
  action = "",
  search = "",
  from = "",
  to = "",
  page = 1,
  limit = 25,
} = {}) => {
  const params = new URLSearchParams({ page, limit });
  if (universityId) params.set("universityId", universityId);
  if (organizationId) params.set("organizationId", organizationId);
  if (intake) params.set("intake", intake);
  if (action) params.set("action", action);
  if (search) params.set("search", search);
  if (from) params.set("from", from);
  if (to) params.set("to", to);

  let res = await axios.get(
    basicurl + `/api/student/payout-activity?${params.toString()}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res;
};
